export default function getFaceRecognitionToken() {
  if (window?.location?.host === 'localhost:3000') {
    return '3952854c-fb31-4b51-a44d-8e758ef3f705';
  }

  return 'c041ee3c-1fee-4923-afbf-0255cf9ab6a9';
}
